import { render, staticRenderFns } from "./ResourcePopupView.vue?vue&type=template&id=56a1ef9e&scoped=true&"
import script from "./ResourcePopupView.vue?vue&type=script&lang=js&"
export * from "./ResourcePopupView.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePopupView.vue?vue&type=style&index=0&id=56a1ef9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1ef9e",
  null
  
)

export default component.exports